var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99369 2.7958C7.33334 3.16715 7.30831 3.74416 6.93778 4.08457L4.24986 6.55405H18.0899C18.5925 6.55405 19 6.96244 19 7.46621C19 7.96999 18.5925 8.37838 18.0899 8.37838H1.91015C1.53483 8.37838 1.19801 8.14747 1.06195 7.79689C0.925886 7.44632 1.0185 7.04799 1.29516 6.79381L5.70782 2.73976C6.07834 2.39935 6.65404 2.42444 6.99369 2.7958ZM16.0876 12.4324L1.91015 12.4324C1.40751 12.4324 1.00004 12.024 1.00004 11.5203C1.00004 11.0165 1.40751 10.6081 1.91015 10.6081L18.0899 10.6081C18.4468 10.6081 18.7707 10.8172 18.9184 11.1428C19.0661 11.4684 19.0102 11.8505 18.7756 12.12L14.3629 17.1876C14.0324 17.5672 13.4575 17.6063 13.0788 17.2751C12.7001 16.9438 12.661 16.3676 12.9915 15.988L16.0876 12.4324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.09b25ae1fd33ccaef35756b368406e8f.svg";
export { ForwardRef as ReactComponent };